// SPDX-License-Identifier: AGPL-3.0-or-later

type CssLengthVariables = Record<`--${string}`, string>;

export const PROFILE_POPOUT_GEOMETRY = {
	contentWidthPx: 300,
	contentHeightPx: 520,
	borderWidthPx: 2.5,
	avatarSizePx: 80,
	avatarBorderPx: 4,
	bannerHeightPx: 105,
	headerHeightPx: 140,
} as const;

export const PROFILE_POPOUT_OUTER_WIDTH_PX =
	PROFILE_POPOUT_GEOMETRY.contentWidthPx + PROFILE_POPOUT_GEOMETRY.borderWidthPx * 2;

export const PROFILE_POPOUT_OUTER_HEIGHT_PX =
	PROFILE_POPOUT_GEOMETRY.contentHeightPx + PROFILE_POPOUT_GEOMETRY.borderWidthPx * 2;

export const PROFILE_POPOUT_GEOMETRY_STYLE: CssLengthVariables = {
	'--profile-popout-content-width': `${PROFILE_POPOUT_GEOMETRY.contentWidthPx}px`,
	'--profile-popout-content-height': `${PROFILE_POPOUT_GEOMETRY.contentHeightPx}px`,
	'--profile-popout-border-width': `${PROFILE_POPOUT_GEOMETRY.borderWidthPx}px`,
	'--profile-popout-avatar-size': `${PROFILE_POPOUT_GEOMETRY.avatarSizePx}px`,
	'--profile-popout-avatar-border': `${PROFILE_POPOUT_GEOMETRY.avatarBorderPx}px`,
	'--profile-popout-banner-height': `${PROFILE_POPOUT_GEOMETRY.bannerHeightPx}px`,
	'--profile-popout-header-height': `${PROFILE_POPOUT_GEOMETRY.headerHeightPx}px`,
};
